<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Views Permissions</h4>
			</div>

			<div class="card-body">
				<div class="row mt-3">
					<div class="col-md-3">
						<h6 class="text-muted text-uppercase fw-semibold mb-2">Select a view</h6>
						<div class="list-group permissions-menu">
							<ng-container *ngFor="let item of menuItems">
								<ng-container *ngIf="!item.isTitle && !item.isLayout">
									<!-- Vista sin submenús -->
									<button type="button" class="list-group-item list-group-item-action d-flex align-items-center" *ngIf="!item.subItems?.length" [class.active]="item.id === selectedView.id" (click)="onViewSelect(item)">
										<i class="{{ item.icon }} me-2"></i>
										<span>{{ item.label | translate }}</span>
									</button>

									<!-- Grupo: el padre solo agrupa, las vistas son sus submenús -->
									<ng-container *ngIf="item.subItems?.length">
										<div class="list-group-item permissions-group d-flex align-items-center">
											<i class="{{ item.icon }} me-2"></i>
											<span>{{ item.label | translate }}</span>
										</div>
										<button type="button" class="list-group-item list-group-item-action permissions-subitem" *ngFor="let subItem of item.subItems" [class.active]="subItem.id === selectedView.id" (click)="onViewSelect(subItem)">
											{{ subItem.label | translate }}
										</button>
									</ng-container>
								</ng-container>
							</ng-container>
						</div>
					</div>

					<div class="col-md-9">
						<app-views-employee [selectedView]="selectedView"></app-views-employee>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
